import { render } from "./QCurrencyInput.vue?vue&type=template&id=90fea2c8&scoped=true"
import script from "./QCurrencyInput.vue?vue&type=script&lang=js"
export * from "./QCurrencyInput.vue?vue&type=script&lang=js"

import "./QCurrencyInput.vue?vue&type=style&index=0&id=90fea2c8&scoped=true&lang=css"

import exportComponent from "/var/www/dev.newtoncommoditiesscripts.com/vue-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90fea2c8"]])

export default __exports__